import { Box, Button, Container, Paper, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Subheader } from 'components';
import CategoryDetails from 'features/category/CategoryDetails';
import { useCategory } from 'hooks';

const CategoryShow = ({ ...props }) => {
	const navigate = useNavigate();
	const { id } = useParams();
	const { categoryId, isLoading, isLoaded, category, findCategory } =
		useCategory({
			id: id
		});

	useEffect(() => {
		if (id) findCategory(id);
	}, []);

	return (
		<>
			<Subheader
				title={isLoading ? 'Loading...' : category && category?.name}
				buttons={[
					<Button
						onClick={() => navigate(`/categories/${id}/edit`)}
						color="primary"
						variant="contained"
					>
						Edit
					</Button>
				]}
			/>
			<Container>
				<Paper>
					<Box p={4}>
						<CategoryDetails category={category && category} />
					</Box>
				</Paper>
			</Container>
		</>
	);
};

export default CategoryShow;
